import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountSettingsService } from '../account-settings.service';
import { Card, CardMetadata, Subscription } from '../../shared/models/plans';
import { AmplitudeService } from 'app/shared/services/amplitude.service';

@Component({
  selector: 'cc-plan',
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.scss']
})
export class PlanComponent implements OnInit {
  public subscription$: Observable<Subscription>;
  public card$: Observable<Card>;
  public cardMetadata$: Observable<CardMetadata>;
  public isChangingPlans = false;

  constructor(private accountSettingsService: AccountSettingsService, private amplitudeService: AmplitudeService) {}

  ngOnInit() {
    this.subscription$ = this.accountSettingsService.getSubscription();
    this.card$ = this.accountSettingsService.getCard();
    this.cardMetadata$ = this.accountSettingsService.getCardMetadata();
  }

  onChangeCard() {
    this.amplitudeService.logEvent('Panel:Account:Plan: Change card');
  }
}
